<template>
    <div class="fax-preview">
        <v-layout row align-center class="mb-2">
            <div v-if="row.fileName" class="fax-file-name">
                <v-icon small class="mr-1">mdi-paperclip</v-icon>
                {{ row.fileName }}
            </div>
            <v-spacer></v-spacer>
            <v-btn
                v-if="file.fileURL"
                small
                outline
                color="success"
                class="mr-2"
                @click="fullScreen = true"
            >
                View full screen
            </v-btn>
            <v-btn
                v-if="file.fileURL"
                small
                outline
                color="success"
                :href="file.fileURL"
                target="_blank"
                rel="noopener"
                class="mr-2"
            >
                Open
            </v-btn>
            <v-btn
                v-if="!hideAssign && !row.accountID && openAssignFax"
                small
                color="success"
                dark
                @click="openAssignFax(row)"
            >
                Assign Account
            </v-btn>
        </v-layout>

        <div v-if="row.text" class="fax-plain-text mb-3">{{ row.text }}</div>

        <div v-if="loading" class="fax-preview-loading">
            <v-progress-circular indeterminate color="success" size="28"></v-progress-circular>
            <div class="mt-2">Loading fax...</div>
        </div>
        <img
            v-else-if="kind === 'image'"
            class="fax-preview-image"
            :src="file.fileURL"
            :alt="file.fileName"
        />
        <div v-else-if="kind === 'pdf' || kind === 'other'" class="fax-preview-frame-wrap">
            <iframe
                class="fax-preview-frame"
                :src="previewUrl"
            ></iframe>
        </div>
        <div v-else-if="!row.hasAttachment" class="grey--text">
            No attachment
        </div>
        <document-preview-dialog
            v-model="fullScreen"
            :url="file.fileURL"
            :name="file.fileName || row.fileName"
            :kind="kind"
        ></document-preview-dialog>
    </div>
</template>
<script>
export default {
    inject: {
        openAssignFax: {
            default: null,
        },
    },
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
        hideAssign: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            file: {},
            fullScreen: false,
        };
    },
    computed: {
        kind() {
            return this.fileKind(this.file);
        },
        previewUrl() {
            if (!this.file || !this.file.fileURL) {
                return "";
            }

            if (this.kind === "pdf" && this.file.fileURL.indexOf("#") === -1) {
                return this.file.fileURL + "#toolbar=0&navpanes=0&view=FitH";
            }

            return this.file.fileURL;
        },
    },
    async created() {
        await this.loadFile();
    },
    methods: {
        async loadFile() {
            if (!this.row || !this.row.id || !this.row.hasAttachment) {
                return;
            }

            this.loading = true;

            try {
                const file = await this.$http.get(
                    "api/faxes/getFile?faxID=" + this.row.id,
                );
                this.file = file || {};
            } catch (e) {
                this.file = {};
            }

            this.loading = false;
        },
        fileKind(file) {
            const name = ((file && file.fileName) || "").toLowerCase();
            const type = ((file && file.contentType) || "").toLowerCase();
            const ext = name.includes(".") ? name.split(".").pop() : "";

            if (
                type.startsWith("image/") ||
                ["jpg", "jpeg", "png", "gif", "webp", "bmp", "tif", "tiff"].includes(ext)
            ) {
                return "image";
            }
            if (type === "application/pdf" || ext === "pdf") {
                return "pdf";
            }
            if (file && file.fileURL) {
                return "other";
            }

            return "";
        },
    },
};
</script>
<style>
.fax-preview {
    max-width: 1000px;
    padding: 0 4px 12px 16px;
}

.fax-file-name {
    color: #607d8b;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.fax-plain-text {
    white-space: pre-line;
    line-height: 1.45;
}

.fax-preview-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    color: #90a4ae;
    font-size: 13px;
}

.fax-preview-image {
    display: block;
    max-width: 100%;
    max-height: 80vh;
    margin: 0 auto;
    border-radius: 6px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
}

.fax-preview-frame-wrap {
    background: #eceff1;
    border-radius: 8px;
    padding: 12px;
    box-shadow: inset 0 0 0 1px #e0e0e0;
}

.fax-preview-frame {
    display: block;
    width: 100%;
    height: 78vh;
    border: 0;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
}
</style>
